<template>
  <div class="change-password">
    <h4>Odzyskaj hasło</h4>
    <p>Podaj swój adres poniżej a otrzymasz email z instrukcją zmiany hasła.</p>
    <div class="input-field">
      <custom-input
          v-model="email"
          placeholder="e-mail"
          required
          type="email"
      />
      <p
          class="error-msg"
          v-if="msg"
      >
        {{ msg }}
      </p>
    </div>
    <custom-button
        class="login-button"
        @click="sendMail"
        button-name="Wyślij"
    />
    <div class="text-button">
      <div
          class="small-text"
          @click="$emit('forgot-password')">
        Logowanie
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

import CustomButton from '../common/CustomButton.vue';
import CustomInput from '../common/CustomInput.vue';

export default {
  name: 'ChangePasswordForm',

  components: { CustomButton, CustomInput },

  setup() {
    const email = ref('');
    const msg = ref('');

    function validationForm() {
      // eslint-disable-next-line
      const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (!email.value) msg.value = 'Pole email nie może być puste';
      else if (!regex.test(String(email.value).toLowerCase())) msg.value = 'Niewłaściwy format email';
    }

    function sendMail() {
      msg.value = '';
      validationForm();
      if (!msg.value) {
        console.log('Tu będzie zapytanie');
      }
    }

    return {
      email,
      msg,
      sendMail,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.change-password {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 265px;
  justify-content: center;
  padding-bottom: 20px;
  text-align: center;
  width: 300px;

  h4 {
    color: $dark-grey;
    margin: 10px;
    text-align: center;
  }

  p {
    color: $dark-grey;
    margin-top: 0;

    &.error-msg {
      text-align: left;
      color: $red;
      font-size: 12px;
      margin-top: 3px;
    }
  }

  .input-field {
    border-radius: 5px;
    height: 30px;
    margin-bottom: 20px;
    width: 300px;
  }

  .login-button {
    background-color: $light-green;
    border-radius: 5px;
    border: 1px solid $light-green;
    color: $white;
    height: 40px;
    width: 300px;
  }

  .text-button {
    display: flex;
    width: 300px;
    justify-content: flex-end;

    .small-text {
      color: $light-green;
      cursor: pointer;
      margin-top: 8px;
      font-size: 14px;
    }
  }
}
</style>
